<template>
   <div class="outerCtn">
     <div>
       <img src="@/assets/phoneService/banner1.png" alt="" srcset="" style="width:100%">
     </div>
    <div class="mytabs">
        <div v-for="(item,index) in tabs" :key="item.key" :style="{color:item.isActive ? '#3170FF':'#FFF' , borderBottom:item.isActive ? '2px solid #3170FF' : 'none'}" @click="changeActive(index)">
            {{ item.name }}
        </div>
    </div>
    <div class="article" v-if="activeIndex == 0">
        <p>用户痛点</p>
        <div class="imgCtn">
            <img src="@/assets/home_line.png" alt="" srcset="">
        </div>
        <div class="detail">
            <div v-for="(item,index) in point" :key="index">
                <div class="hardWare">
                    <img :src="item.assets" alt="" style="height:20px">
                    {{item.title}}
                </div>
                <div class="hardWare-text">
                    {{item.content}}
                </div>
            </div>
        </div>
    </div>
    <div class="article" v-if="activeIndex == 1">
        <p>方案优势</p>
        <div class="imgCtn">
            <img src="@/assets/home_line.png" alt="" srcset="">
        </div>
        <div class="detail">
           <img src="@/assets/phoneService/pic.png" alt="" srcset="" style="height:133px">
           <div v-for="item in advantage" :key="item.id" class="ctn">
             <div class="pointTitle">
               <div class="point"></div>
               <div class="pointText">{{item.title}}</div>
             </div>
             <div v-for="items in item.content" :key="items.id">
               <div class="pointDesc">{{ items.desc }}</div>
             </div>
           </div>
        </div>
    </div>
    <div class="article" v-if="activeIndex == 2">
        <p>客户价值</p>
        <div class="imgCtn">
            <img src="@/assets/home_line.png" alt="" srcset="">
        </div>
        <div class="detail">
            <img src="@/assets/phoneService/light.png" alt="" srcset="" width="100%">
        </div>
    </div>
    <div class="article" v-if="activeIndex == 3">
        <p>落地案例</p>
        <div class="imgCtn">
            <img src="@/assets/home_line.png" alt="" srcset="">
        </div>
        <div class="detail">
            <el-carousel height="325px"  arrow="always">
                <el-carousel-item v-for="(item,index) in carouselData" :key="index" class="adjust">
                    <p style="font-size:18px;margin-bottom:16px">{{item.title}}</p>
                    <img :src="item.assets" alt="" srcset="" style="height:100px" @click="tolink(index)">
                    <p style="font-size:12px;letter-spacing:1.5px;line-height:18px;text-indent: 1cm;text-align:left;margin-top:20px;">{{item.content}}</p>
                </el-carousel-item>
            </el-carousel>
        </div>
    </div>
   </div>
</template>

<script>
import cqjy from '../../../assets/userVal/cqjy.png'
import ifc from '../../../assets/userVal/ifc.png'
import xc from '../../../assets/userVal/xc.png'
import ysgj from '../../../assets/userVal/ysgj.png'
import ftxl from '../../../assets/userVal/ftxl.png'
import zd from '../../../assets/userVal/zd.png'
import yh from '../../../assets/userVal/yh.png'
import img1 from '../../../assets/phoneService/1.png';
import img2 from '../../../assets/phoneService/2.png';
import img3 from '../../../assets/phoneService/3.png';
import img4 from '../../../assets/phoneService/4.png';
import img5 from '../../../assets/phoneService/5.png';
import img6 from '../../../assets/phoneService/6.png';

export default {
    data() {
        return {
            tabs:[
                {name:'用户痛点',key:1,isActive:true},{name:'方案优势',key:2,isActive:false},{name:'客户价值',key:3,isActive:false},{name:'落地案例',key:4,isActive:false}
            ],
            activeIndex:0,
            point:[
              {assets:img1,content:'转供电主体收费混乱，物业垫资一般2月以上',title:'垫资长',},
              {assets:img2,content:'电费收取困难，成本高，账期长，坏账多',title:'收费难',},
              {assets:img3,content:'旧式电表寿命到期，精度差，损耗高',title:'计费难',},
              {assets:img4,content:'人工统计数据，易出错，易被盗电',title:'易出错',},
              {assets:img5,content:'公区损耗数据模糊，无合理规划，线损率高',title:'易损耗',},
              {assets:img6,content:'人工成本高，能耗管理效率低',title:'成本高',}
            ],
            advantage:[
              {content:[{desc:'建筑能源管理系统',id:1},{desc:'能源监管，高效运营',id:2}],title:'控能耗',},
              {content:[{desc:'设备运维管理系统',id:3},{desc:'提升员工工作效率，降低人工成本',id:4}],title:'增效率',},
              {content:[{desc:'暖通AI节能控制决策系统',id:5},{desc:'提升环境品质，增加舒适感及安全感',id:6}],title:'提品质',},
              {content:[{desc:'智能化集成系统',id:7},{desc:'固定资产增值，数据价值转换',id:8}],title:'促增值',},
            ],
            carouselData:[
                {title:'重庆·金源时代购物中心',link:"https://mp.weixin.qq.com/s/tvHmaBGxhL-IxdJn4_UBzw", assets:cqjy,content:'项目位于重庆市江北区观音桥正前方，重庆最具发展潜力的北滨路核心区金源大道路口，是世纪金源集团继成功打造观音桥地标项目金源大饭店后，在重庆的又一地标性建筑，总商业面积35万平方米。包含日用百货、大型超市、专业市场、家居卖场等多种业态。'},
                {title:'济南IFC中央公馆',link:"https://mp.weixin.qq.com/s/T-dGlrs_G0y04sW5E-wgeA", assets:ifc,content:'济南IFC中央公馆位于济南市历下化纤厂路，总建筑面积16.4万㎡，共计房屋1444户。IFC中央公馆身处济南CBD，占整个CBD面积的1/4。业态分布主要为420米山东第一高楼办公、酒店、高端主题商业、新天地商业街、办公及高端住宅。项目开发分为五期。'},
                {title:'西昌唐园',link:"https://mp.weixin.qq.com/s/c2BEpgaypMFExaH8lqCHmA", assets:xc,content:'唐园坐落于四川省西昌市建昌东路，项目计划总投资7.78亿元，规划用地总面积约11万平方米，建筑总面积7万多平方米。该项目作为西昌市创建“省级公园城市”的重点文旅项目，是西昌深入挖掘历史文化、展示本地地域特色、拓展城市空间的重点体现。致力于打造成唐“潮”艺术生活街区，集文化旅游、商业为一体的综合性城市公园。'},
                {title:'广州合景誉山国际',link:"https://mp.weixin.qq.com/s/aK6TEqwqus8B9y1-xVF1sA", assets:ysgj,content:'合景誉山国际项目位于广州市增城区，总投资额约110亿元，建筑面积254万平方米，是集酒店、会展、购物城、写字楼、住宅于一身的3000亩大型综合体。合景誉山国际分五期开发，首期包括酒店、会展、购物、商业街、写字楼和住宅，建筑面积超过30万平方米。二期为纯别墅区，分南北两区，共有独栋、双拼等别墅。三期为洋房区。除此以外，小区周边规划有医院、国际学校、运动场馆、文化活动中心幼儿园、小学、中学等。'},
                {title:'西安富平新里城',link:"https://mp.weixin.qq.com/s/MB0T00p7xizsLop5I_FnxA", assets:ftxl,content:'西安富平绿地新里城，位于西安市荆山大道与怀德大街交汇处。项目隶属于绿地集团新里系的高端产品系，它缘起新式里弄，中西合璧，充分结合了“传统，品质，人文，智慧”四大特质，打造高端人文社区，主要针对城市菁英。项目总占地228亩，总规划33万方、42栋楼，容积率低至1.8，分两个地块开发。产品含住宅、商业5300㎡及教育配套设施。'},
                {title:'中电建云立方',link:"https://mp.weixin.qq.com/s/QfYSSSAksVhnLmOBibBHeQ", assets:zd,content:'云立方项目地处成都市龙泉驿区龙城大道816号，项目总占地128亩，项目住宅部分建筑面积38.2万平米，并配套4.1万平米建面商业，项目内还规划有幼儿园。'},
                {title:'广州永荟广场',link:"https://mp.weixin.qq.com/s/2DkY2nsVtulyPSBoiqV9LA", assets:yh,content:'永荟广场项目位于广州东TOD国际交通枢纽附近（香山大道与创新大道交汇处），占地面积约21万㎡，总建面约75万㎡大型商业综合体。项目落成后将成为新塘开发区的商业核心圈，项目本身自带建面约23万㎡永旺梦乐城华南旗舰店，加上项目旁的新塘万达广场等商业，将为区域带来百万消费人群。'},
            ]
        }
    },
    methods:{
        changeActive(index){
            for (let i = 0; i < this.tabs.length; i++) {
                if(index == i){
                    this.tabs[i].isActive = true
                }else{
                    this.tabs[i].isActive = false
                }
            }
            this.activeIndex = index
        },
        tolink(i){
            let link = this.carouselData[i].link
            window.open(link, '_blank')
        }
    }
}
</script>

<style lang="scss" scoped>
.mytabs{
    display: flex;
    justify-content: space-between;
    padding: 0 14px;
    font-size: 14px;
    font-family: SourceHanSansCN-Regular;
    padding-top:19px;
    height: 50px;
    border-radius: 4px;
}
.outerCtn{
    background-color: #24282E;
    color: white;
    min-height: 100vh;
    .article{
        margin: 40px 20px 0 20px;
        padding-bottom: 10px;
        text-align: left;
        p{
            font-size: 22px;
            font-family: Alibaba PuHuiTi;
            font-weight: 500;
            padding-bottom: 10px;
            text-align: center;
        }
        .imgCtn{
          display: flex;
          justify-content: center;
          align-items: center;
          img{
            width:84px;
            height: 3px;
          }
        }
    }
    .detail{
        background-color: #2d2f33;
        margin-top: 20px;
        border-radius: 4px;
        overflow: hidden;
        padding: 26px 20px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        .ctn{
          padding: 0 22px;
          margin-top: 20px;
        }
        .pointTitle{
          text-align: left;
          display: flex;
          align-items: center;
          font-size: 12px;
          .point{
            width: 10px;
            height: 10px;
            background-color: #3170FF;
            border: 2px solid white;
            transform: rotate(45deg);
            margin-left: 10px;
          }
          .pointText{
            font-size: 14px;
            font-family: Alibaba PuHuiTi;
            font-weight: 500;
            color: #3170FF;
            padding-left: 13px;
          }
        }
        .pointDesc{
          margin-top: 4px;
          font-size: 12px;
          font-family: Alibaba PuHuiTi;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 18px;
          padding: 0 34px;
        }
        .detail-content{
            margin: 15px 0;
            font-size: 12px;
            letter-spacing:1.5px;
            line-height:16px
        }
        .describeTion{
            font-size: 12px;
            letter-spacing:2px;
            line-height:16px;
            text-indent: 0.5cm;
            text-align: left;
            margin-top: 10px;
        }
    }
    .detail .hardWare{
        text-align: left;
        display: flex;
        font-size: 14px !important;
        font-weight: 500;
        color: #3170FF;
        align-items: center;
        margin-top: 6px;
        img{
            padding-right: 8px;
        }
    }
    .hardWare-text{
        font-size: 12px;
        letter-spacing:2px;
        line-height:24px;
        margin-left: 32px;
    }
}
.adjust{
    display: flex;
    flex-direction: column;
    align-items: center;
}
</style>
<style>
   .article .detail .el-carousel__indicator--horizontal{
        display: none;
    }
    .article .detail .el-carousel__arrow{
        top:30%;
    }
</style>



// WEBPACK FOOTER //
// src/components/page/phone/phoneService.vue